import { z } from 'zod'

export const COACHING_SHELL_Z5_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellZ5ResponseSchema = z.unknown()
export type CoachingShellZ5Response = z.infer<typeof coachingShellZ5ResponseSchema>
